const FILE_MAX_SIZE = 1048576

type ErrorResponse = {
  isError: true
  errorMessage: string
}

type SuccessResponse = {
  isError: false
}

export const validateInputImage = (e): ErrorResponse | SuccessResponse => {
  let file = e.target.files[0]
  if (!e || !file) return

  const imageTypePattern = /^image\/(jpeg|jpg|png)$/
  const isCorrectType = imageTypePattern.test(file.type)

  if (!isCorrectType) {
    return { isError: true, errorMessage: 'Allowed file types: png, jpg, jpeg' }
  }

  if (file.size > FILE_MAX_SIZE) {
    return { isError: true, errorMessage: 'Image over maximum 1 MB' }
  }

  return { isError: false }
}
